import { RouteObject } from "react-router";

import { convertRouteModule } from "../../lib/routing";

export const emailVerificationRoutes: Array<RouteObject> = [
  {
    index: true,
    shouldRevalidate: () => false,
    lazy: async () => convertRouteModule(await import("./verify-email")),
  },
];

export const completeProfileRoutes: Array<RouteObject> = [
  { index: true, lazy: async () => convertRouteModule(await import("./complete-profile")) },
];

export const acceptInvitationRoutes: Array<RouteObject> = [
  { index: true, lazy: async () => convertRouteModule(await import("./invitation")) },
];
